import React from 'react'
import moment from 'moment'
import { Icon} from 'antd'
import './index.scss'

export default ({ recentActivities }) => (
  <div className='recent-activity-list'>
    <div className="head">
      <h3>
        <Icon type="clock-circle-o" /> Recent Activity
      </h3>
    </div>
    <div className="body">
      {recentActivities.map((ra, index) =>
        <RecentActivityItem key={index} {...ra} />)}
    </div>
  </div>
)

const RecentActivityItem = ({ id, activity_date, message, type }) => (
  <div className='recent-activity-item'>
    <div className="activity_date">
      {moment(activity_date).fromNow()}
    </div>
    <div className="message">
      <Icon type={`cloud-${type}-o`} />
      <p>
        {message}
      </p>
    </div>
  </div>
)